<template>
  <div class="login-card__verification-email">
    <h1 class="login-card__title">
      {{ trans.get('auth.card.verification.email.header') }}
    </h1>

    <div class="login-card__verification-icon">
      <i class="demo-icon icon-mail-sec"></i>
    </div>

    <div v-if="linkResent">
      <p class="login-card__verification-success">
        {{ trans.get('auth.card.verification.email.link_successfully_resent') }}
      </p>
    </div>

    <p class="login-card__verification-desc">
      {{ trans.get('auth.card.verification.email.message') }}
    </p>

    <div class="login-card__verification-email-name">
      {{ form.email }}
    </div>

    <div class="login-card__verification-email-button" v-if="mailWebObject">
      <a
        :href="mailWebObject.url"
        type="button"
        class="button button__outline button__small mb-2"
        target="_blank"
      >
        <span>
          {{ trans.get('auth.card.buttons.open_email') }}
          <img class="pl-2" v-if="mailWebObject.image" :src="mailWebObject.image" :alt="mailWebObject.name" />
        </span>
      </a>
    </div>

    <div v-if="changeEmail" class="login-card__buttons-box">
      <div>
        <validation-observer ref="form" v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(onSubmit)">
            <div class="form-group">
              <validation-provider name="email" rules="required" v-slot="{ errors }" mode="eager">
                <div class="change-email-input">
                  <label for="email">
                    {{ trans.get('auth.card.verification.email.change_email_label') }}
                  </label>
                  <input
                    type="email" id="email" class="input-text input-text__underline"
                    v-model="email" placeholder="E-mail"
                  >
                </div>
                <span class="text-danger">{{ errors[0] }}</span>
              </validation-provider>
            </div>

            <button type="submit" class="button button__outline button__small mb-2">
              {{ trans.get('auth.card.verification.email.change_email_form_button') }}
            </button>
          </form>
        </validation-observer>
      </div>
    </div>

    <div v-if="!changeEmail" class="login-card__verification-receive_info" v-html="trans.get('auth.card.verification.receive_info')">
    </div>

    <div class="login-card__buttons-box">
      <button
        type="button"
        class="button button__outline button__small mb-2"
        @click="resendLink"
      >
        {{ trans.get('auth.card.buttons.resend_link') }}
      </button>

      <button
        type="button"
        class="button button__outline button__small mb-2"
        @click.prevent="changeEmail = true"
      >
        {{ trans.get('auth.card.buttons.change_email') }}
      </button>
    </div>

    <div
      class="login-card__btn-desc"
      v-html="trans.get('auth.card.registration_agreement', {link1: '/abgn', link2: '/privacy'})"
    ></div>

  </div>
</template>
<script>
import EmailDomainMixin from './EmailDomainMixin.js';

export default {
  props: ['swapComponent', 'form'],
  mixins: [EmailDomainMixin],
  data: () => ({
    linkResent: false,
    changeEmail: false,
    email: '',
  }),
  methods: {
    resendLink() {
      const self = this;
      axios
        .post(zRoute('verification.email.resend'))
        .then(
          function (response) {
            self.linkResent = true;
          },
          function (error) {
            self.linkResent = false;
            if (error.response.status === 422) {
              self.$refs.form.setErrors(error.response.data.errors);
            }
          }
        );
    },
    logout() {
      const self = this;
      axios
        .post(zRoute('logout'))
        .then(function (response) {
          self.swapComponent('auth-welcome-card');
        });
    },
    async refreshCSRFToken() {
      axios
        .get(zRoute('ajax.csrf_token'))
        .then((response) => {
          const token = response.data.csrfToken;
          document
            .querySelector('meta[name=csrf-token]')
            .setAttribute('content', token);
          window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
        });
    },
    onSubmit() {
      const self = this;
      axios
        .post(zRoute('register.email.update'), { email: this.email, })
        .then(function (response) {
          self.form.email = self.email;
          self.changeEmail = false;

          self.$notify({
            group: 'custom-template',
            type: 'info',
            title: 'Info',
            text: self.trans.get('auth.card.verification.email.link_successfully_resent'),
            duration: 5000,
            data: {},
          });
        }, function (error) {
          if (error.response.status === 422) {
            if (!('email' in error.response.data.errors)) {
              self.$refs.form.setErrors({ 'email': error.response.data.errors[Object.keys(error.response.data.errors)[0]][0] });
            } else {
              self.$refs.form.setErrors(error.response.data.errors);
            }
          }
        });
    },
  },
  activated() {
    this.linkResent = false;
    this.refreshCSRFToken();
  },
  mounted() {
    this.email = this.form.email;
  }
};
</script>
<style scoped>
</style>
